<ng-container *ngIf="invitee">
  <div
    class="list-item-header"
    [attr.data-cy]="invitee.status">
    <div
      class="header-left"
      [attr.data-cy]="'user-list-item-id-' + invitee.userId">
      <div>
        <div class="employee-name">
          <div class="first-name">
            {{
              loggedInCustomer?.prioritizeEmployeeLastName
                ? invitee.personalData.lastName
                : invitee.personalData.firstName
            }}
          </div>
          <div class="last-name">
            {{
              loggedInCustomer?.prioritizeEmployeeLastName
                ? invitee.personalData.firstName
                : invitee.personalData.lastName
            }}
          </div>
        </div>
        <div
          class="employee-customer"
          *ngIf="invitee.originCustomer">
          Via
          {{
            invitee.originCustomer.displayName +
              (invitee.originCustomer.tariff
                ? " /" + invitee.originCustomer.tariff
                : "")
          }}
        </div>
      </div>
    </div>
    <div class="header-right">
      <mat-spinner
        diameter="24"
        *ngIf="!inviteeUser && invitee.userId"></mat-spinner>
      <app-previous-jobs-logs
        [user]="inviteeUser ?? undefined"
        [invitee]="invitee"
        [departmentId]="employment?.department?.id ?? ''">
      </app-previous-jobs-logs>
      <availability-percentage-bar
        *ngIf="
          (inviteeUser?._id || invitee.personalData.externalAvailabilities) &&
          fromDate &&
          toDate
        "
        [user]="inviteeUser"
        [externalAvailabilityDays]="
          invitee.personalData.externalAvailabilityDays
        "
        [fromDate]="fromDate"
        [toDate]="toDate"
        [availabilityPercentage]="invitee?.matchPercentage || 0"
        [employmentId]="employment?._id"></availability-percentage-bar>
      <button
        type="button"
        class="transparent-pill-button icon-only"
        (click)="$event.stopPropagation(); openBottomSheet()">
        <app-employment-invitee-status-icon
          displayShowHistoryTooltip
          [status]="invitee.status"></app-employment-invitee-status-icon>
      </button>
      <button
        type="button"
        class="transparent-pill-button icon-only"
        [disabled]="
          !availableActions.length ||
          isDisabled ||
          (invitee.status !== statusEnum.BOOKED && isClosed)
        "
        [matMenuTriggerFor]="actionsMenu"
        (click)="$event.stopPropagation()"
        data-cy="invitee-actions-button">
        <mat-icon svgIcon="menu-dot"></mat-icon>
      </button>
    </div>
  </div>
  <div
    class="collapse-wrapper"
    [class.collapsed]="detailsCollapsed">
    <div
      class="collapse-child"
      (click)="$event.stopPropagation()">
      <div>
        <ng-container *ngIf="availabilityNotes$ | async as notes">
          <div
            class="availability-notes"
            *ngIf="notes.length">
            <h4 class="availability-notes-title">
              {{ "availabilityNotes" | i18n }}
            </h4>
            <div
              class="availability-note"
              *ngFor="let note of notes">
              {{
                "availabilityNoteFormat"
                  | i18n
                    : {
                        start: note.start | displayDbDate: "dd.MM.yyyy",
                        end: note.end | displayDbDate: "dd.MM.yyyy",
                        note: note.notes
                      }
              }}
            </div>
          </div>
        </ng-container>
        <employment-mini-availability-match
          *ngIf="
            !detailsCollapsed && fromDate && toDate && invitee.matchPercentage
          "
          [user]="inviteeUser"
          [externalAvailabilities]="invitee.personalData.externalAvailabilities"
          [fromDate]="fromDate"
          [toDate]="toDate"
          [availabilityPercentage]="
            invitee.matchPercentage
          "></employment-mini-availability-match>
        <user-list-item-details
          class="user-details mt-1"
          [showContactInfo]="($showContactInfo | async) || false"
          [user]="inviteeUser"
          [invitee]="invitee"></user-list-item-details>
      </div>
    </div>
  </div>
</ng-container>

<mat-menu
  #actionsMenu="matMenu"
  class="fixed-icon-mat-menu themed">
  <button
    *ngFor="let action of availableActions"
    mat-menu-item
    type="button"
    [attr.data-cy]="action.cypressName"
    (click)="action.run()"
    [class.yellow-icon]="action.theme === inviteeActionTheme.YELLOW_ICON"
    [class.success-icon]="action.theme === inviteeActionTheme.SUCCESS_ICON"
    [class.danger-icon]="action.theme === inviteeActionTheme.DANGER_ICON"
    [class.danger-item]="action.theme === inviteeActionTheme.FULL_DANGER">
    <mat-icon [svgIcon]="action.icon"></mat-icon>
    {{ (action.label | i18n | titlecase) || action.label }}
  </button>
</mat-menu>
